// Start: Plus add charge into price of product
let formatter = new Intl.NumberFormat('de-DE', {
  style: 'currency',
  currency: 'EUR',
});

let originPriceText = null;
let originPrice = null;
let interval3 = setInterval(function () {
  let ap_elements = document.querySelector('#avpoptions-container__v2');
  if (ap_elements) {
    if (!originPriceText) {
      originPriceText = $('.price-item.price-item--regular')[0].innerHTML;
      originPrice = parseFloat($('.price-item.price-item--regular')[0].innerHTML.replace('€', '').replace(',', '.').replace(/[^\d.]/g, ''));
    }	
    if (originPriceText && originPrice && $('#avp-productoption-total-add').is(':visible')){
      let addChargePrice = parseFloat($('#avp-productoption-totalpriceadd')[0].innerHTML.replace('€', '').replace(',', '.').replace(/[^\d.]/g, ''));
      let newPrice = originPrice + addChargePrice;
      $('.price-item.price-item--regular')[0].innerHTML = formatter.format(newPrice);

    } else {
      $('.price-item.price-item--regular')[0].innerHTML = originPriceText;
    }
  } 
}, 100);
// End: Plus add charge into price of product

// let interval1 = setInterval(function () {
//   let apElements = document.querySelector('#avpoptions-container__v2');
//   if (apElements){
//     let optionMonneys = $('#avpoptions-container__v2 option span.money')
  
//     for (let key of optionMonneys) {
//       key.innerHTML = ""
//     }
//     clearInterval(interval3);
//   }
// }, 100);

let interval = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  if (apElements){
    $('.apo-file .apo-file__lable span:last-child').text("Import ton fichier");
    clearInterval(interval);
  }
}, 100);